import {h, Fragment} from "preact"
import { wrapContent } from "./ContentWrapper"
import { InfiniteScroll } from "@nosto/preact"

import Toolbar from "./Toolbar"
import MobilePopularFilters from "./facets/MobilePopularFilters"
import SelectedFilters from "./SelectedFilters"
import Sidebar from "./Sidebar"
import Products from "./Products"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"

export function CategoryBody({ loading, foundProducts }) {
    return (foundProducts ? (
        <>
            <Toolbar />
            <MobilePopularFilters />
            <SelectedFilters />
            <div class="flex px-pagemargin">
                <Sidebar />
                <Products />
            </div>
            <Pagination />
        </>
    ) : loading ? (
        <Loader />
    ) : (
        <NoResults />
    ))
}

export function CategoryBodyInfiniteScroll({ loading, foundProducts }) {
    if (!foundProducts) return loading ? <Loader /> : <NoResults />
    return (
        <>
            <SelectedFilters />
            <Toolbar />
            <InfiniteScroll>
                <Products />
            </InfiniteScroll>
        </>
    )
}

// replace with following line to enable infinite scroll
// export default wrapContent("category", CategoryBodyInfiniteScroll)
export default wrapContent("category", CategoryBody)
